export default __webpack_public_path__ + "static/media/n2-mark-disk.f0b99389.svg";